import { render, staticRenderFns } from "./BreadModelChildDetachDialog.vue?vue&type=template&id=5842053e&scoped=true&"
import script from "./BreadModelChildDetachDialog.vue?vue&type=script&lang=js&"
export * from "./BreadModelChildDetachDialog.vue?vue&type=script&lang=js&"
import style0 from "./BreadModelChildDetachDialog.vue?vue&type=style&index=0&id=5842053e&scoped=true&lang=css&"
import style1 from "./BreadModelChildDetachDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842053e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
